export default "__VITE_ASSET__ohySEr0Y__";